import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

export interface Breadcrumb {
  id: string;
  name: string;
}

@UntilDestroy()
@Component({
  selector: 'sd-connect-file-breadcrumb',
  imports: [CommonModule],
  templateUrl: './connect-file-breadcrumb.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConnectFileBreadcrumbComponent {
  readonly breadcrumbs = input<Breadcrumb[]>([]);
  readonly disabled = input(false);

  readonly onBreadcrumbClick = output<Breadcrumb>();

  breadcrumbClick(breadcrumb: Breadcrumb) {
    if (this.disabled()) return;

    this.onBreadcrumbClick.emit(breadcrumb);
  }
}
